export const LOGIN_SUCCESS = 'LOGIN_SUCCESS';
export const LOGIN_REQUEST = 'LOGIN_REQUEST';
export const LOGIN_FAILURE = 'LOGIN_FAILURE';

export const REGISTER_REQUEST = 'REGISTER_REQUEST';
export const REGISTER_FAILURE = 'REGISTER_FAILURE';
export const REGISTER_UPDATED_SUCCESS = 'REGISTER_UPDATED_SUCCESS';
export const REGISTER_CREATED_SUCCESS = 'REGISTER_CREATED_SUCCESS';

export const PERSIST_REHYDRATE = 'persist/REHYDRATE';
